import { render, staticRenderFns } from "./WordLearning.vue?vue&type=template&id=4386ad75&scoped=true&"
import script from "./WordLearning.vue?vue&type=script&lang=js&"
export * from "./WordLearning.vue?vue&type=script&lang=js&"
import style0 from "./WordLearning.vue?vue&type=style&index=0&id=4386ad75&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4386ad75",
  null
  
)

export default component.exports